import React, { Component } from "react";
import { TextControl } from '@wordpress/components';


class ButtonText extends Component {

    constructor(props) {
        super(props);
    }



    render() {

        const { attributes: {buttonText}, setAttributes } = this.props;

        const changeFunction = (value) => {
            setAttributes({
                buttonText: value
            });
        }

        return (
            <div className="components-base-control">
                <div className="components-base-control__field">
                    <label className="components-base-control__label">Button Text</label>
                    <TextControl
                        value={ buttonText }
                        onChange={ changeFunction }
                    />
                </div>
            </div>
        );

    }
}


export default ButtonText;